import React from 'react';

import Widgets from '../../widgets/widgets';

export const LayoutBody = () => (
	<div className="layout-body">
		<Widgets />
	</div>
);
